module.exports = __webpack_public_path__ + "img/cabbage-posterized-medium-charlie.49048bc1.png";